import { UserOrEmailMapping } from "../../../features/Admin/typings/admin.types";

export function genZoneAccessWithExternal(zoneAccess: UserOrEmailMapping[]) {
  return zoneAccess.map(visitor => {
    if (visitor.external) {
      return {
        userId: visitor.userId ?? "",
        isRequired: visitor.isRequired ?? true,
        external: visitor.external,
        email: visitor.email ?? ""
      };
    } else {
      return {
        userId: visitor.userId ?? "",
        isRequired: visitor.isRequired ?? true,
        external: visitor.external ?? false
      };
    }
  });
}
